import * as React from "react";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import Button, { type ButtonProps } from "./Button";

interface Props extends ButtonProps {
    floating?: boolean;
}

export default class SaveButton extends React.Component<Props> {
    public render(): React.ReactNode {
        const {
            floating,
            classes: classesProp,
            ...otherProps
        } = this.props;

        const classes = [ "button-save" ];

        if(floating) {
            classes.push("floating");
        }

        if(classesProp) {
            classes.push(...classesProp);
        }

        return (
            <Button
                type="button"
                classes={classes}
                {...otherProps}
            >
                <FontAwesomeLight icon="save" />Save
            </Button>
        );
    }
}
